import { trimAndToUpperCase } from './common'
import { validateRole } from './validate'
import { ROLES } from 'utils/constants/enums'
import { LS_USER_ID, LS_USER_INFO } from 'utils/constants/localStorage'

export const accessToken = () => {
  const name = 'mtcUsrToken='
  const decodedCookie = decodeURIComponent(document.cookie)
  const cookie = decodedCookie.split(';')
  for (let i = 0; i < cookie.length; i++) {
    let cookieStr = cookie[i]
    while (cookieStr.charAt(0) === ' ') {
      cookieStr = cookieStr.substring(1)
    }
    if (cookieStr.indexOf(name) === 0) {
      const accessToken = cookieStr.substring(name.length, cookieStr.length)
      if (accessToken) {
        return `Bearer ${accessToken}`
      }
      return ''
    }
  }
}

export const setAccessToken = (accessToken: string, expiresTime: string) => {
  const date = new Date()
  const aDayTime = 24 * 60 * 60 * 1000
  const expiresDate =
    expiresTime?.split('')?.[1] === 'w' ? 7 * aDayTime : aDayTime

  date.setTime(date.getTime() + expiresDate ?? aDayTime)
  const expires = `expires=${date.toUTCString()}`
  document.cookie = `mtcUsrToken=${accessToken};${expires};path=/;${
    window.location.protocol === 'https' ? 'secure;' : ''
  }`
}

export const isAuth = () => Boolean(accessToken())

export const logOut = () => {
  document.cookie = 'mtcUsrToken=; Max-Age=0; path=/;'
  localStorage.removeItem(LS_USER_INFO)
  localStorage.removeItem(LS_USER_ID)
}

export const getRoles = () => {
  const userRole = localStorage.getItem(LS_USER_INFO) ?? ''
  let role = userRole && (JSON.parse(userRole)?.role ?? '')
  validateRole(role)

  role = trimAndToUpperCase(role)
  const isParentUser = role === ROLES.USER_PARENT
  const isManager = role === ROLES.USER_MANAGER
  const isViewer = role === ROLES.USER_VIEWER
  const isFacilityManager = role === ROLES.USER_FACILITY_MANAGEMENT
  const isFacilityViewer = role === ROLES.USER_BROWSE_FACILITY
  const isDataRegister = role === ROLES.USER_REGISTRATION
  return {
    isParentUser,
    isManager,
    isViewer,
    isFacilityManager,
    isFacilityViewer,
    isDataRegister,
  }
}
